import React, { useId } from 'react';

// The check is cut out of the disc rather than painted over it, so a translucent colour stays even
// and the check shows whatever surface sits behind it.
export const IconCheckCircle: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    const maskId = useId();
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
            <mask id={maskId}>
                <rect width="24" height="24" fill="white" />
                <path d="M8 12.5L10.75 15.25L16 9.5" stroke="black" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
            </mask>
            <circle cx="12" cy="12" r="10" fill="currentColor" mask={`url(#${maskId})`} />
        </svg>
    );
};
